var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FDDFD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#FFF0EC",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2085 15.6633L34.2485 33.01H14.1685L24.2085 15.6633ZM11.8618 31.6767C10.8352 33.45 12.1152 35.6767 14.1685 35.6767H34.2485C36.3018 35.6767 37.5818 33.45 36.5552 31.6767L26.5152 14.33C25.4885 12.5567 22.9285 12.5567 21.9018 14.33L11.8618 31.6767ZM22.8752 22.3433V25.01C22.8752 25.7433 23.4752 26.3433 24.2085 26.3433C24.9418 26.3433 25.5418 25.7433 25.5418 25.01V22.3433C25.5418 21.61 24.9418 21.01 24.2085 21.01C23.4752 21.01 22.8752 21.61 22.8752 22.3433ZM22.8752 29.01H25.5418V31.6767H22.8752V29.01Z",
    fill: "#E42131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/Warning-red.9f56d7ffbce2a4d9c9cec33448fbe36d.svg";
export { ForwardRef as ReactComponent };